export { default as ApiMessage } from '@/api/ApiMessage'
export { default as ApiActions } from '@/api/ApiActions'
export { default as ApiDialog } from '@/api/ApiDialog'
export { default as ApiInit } from '@/api/ApiInit'
export { default as RegRu } from '@/api/RegRu'

import api from '@/modules/axios'

export let ipinfo = api.create({
    baseURL: 'https://ipinfo.io',
    headers: { 'content-type': 'application/json' }
})
